import { graphql } from "@/graphql/generated/gql";

export const municipalPropertyRegisterListQueryDocument = graphql(/* GraphQL */ `
  query MunicipalPropertyRegisterList($input: MunicipalPropertyRegisterListInput!) {
    municipalPropertyRegisterList(input: $input) {
      nodeList {
        ...MunicipalPropertyRegisterFields
      }
      endCursor
      hasNextPage
      totalCount
    }
  }
`);
